"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
require("./Styles/custom.scss");
var React = require("react");
var ReactDOM = require("react-dom");
var react_router_dom_1 = require("react-router-dom");
//import App from './App';
//import { EventHandlerProvider } from './Services/EventHandlerService';
var registerServiceWorker_1 = require("./registerServiceWorker");
require("react-app-polyfill/ie11");
require("react-app-polyfill/stable");
//import { Auth } from './Services/AuthenticationService';
//import { SignalRConnection } from './Services/ConnectionService';
//import { VeriLiteErrorEvent, IVeriLiteEventAction, IVeriLiteEvent } from './Types';
//import { EventModal } from './Components/EventModal';
//import AppLoader, { IAppLoaderState } from './AppLoader'; 
var AuthenticatedApp_1 = require("./AuthenticatedApp");
var AnonymousApp_1 = require("./AnonymousApp");
var NotFound_1 = require("./NotFound");
var History_1 = require("./Utils/History");
var dotenv_1 = require("dotenv");
var Services_1 = require("./Services");
var Endpoints_1 = require("./Utils/Endpoints");
dotenv_1.config();
var reCaptchaEndpoint = "https://www.google.com/recaptcha/api.js?hl=" + (((_b = (_a = document.cookie.split('; .AspNetCore.Culture=').pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift()) === null || _b === void 0 ? void 0 : _b.split('uic%3D').pop()) || "en");
var scriptTag = document.createElement("script");
scriptTag.src = reCaptchaEndpoint;
document.head.appendChild(scriptTag);
Services_1.getJson(Endpoints_1.default.GetResources, undefined, false).then(function (json) {
    window.resources = JSON.parse(json);
});
var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') || undefined;
var rootElement = document.getElementById('root');
//let widthCondition = window.innerWidth > 768;
ReactDOM.render(React.createElement(react_router_dom_1.Router, { history: History_1.default },
    React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { exact: true, path: ['/', '/Dashboard/:path?/:path2?', '/CalibrateScanner', '/Settings/:path?', '/EchoPage'], render: function (props) { return React.createElement(AuthenticatedApp_1.AuthenticatedApp, __assign({}, props)); } }),
        React.createElement(react_router_dom_1.Route, { exact: true, path: ['/Registration/:path?'], render: function (props) { return React.createElement(AnonymousApp_1.AnonymousApp, __assign({}, props)); } }),
        React.createElement(react_router_dom_1.Route, { render: function () { return React.createElement(NotFound_1.default, null); } }))), rootElement);
registerServiceWorker_1.default();
//{
//    shouldRenderApp() ?
//    widthCondition ?
//        <App />
//        :
//        <div>Mobile support comming soon!</div>
//    :
//    Auth.isCallback ? "" :
//        Auth.hasError ? renderAuthError() :
//            <div>Please wait while you are redirected to the login page</div>;
//}
//# sourceMappingURL=index.js.map